import {createApiPath, createFetchAndCall} from './fetch/fetchServices';
import {naicsCodesApiPath} from '../constants/apiConstants';

class NAICSCodesApi {

  static getNaicsCodes(input) {
    const naicsUrl = createApiPath(naicsCodesApiPath, input);
    let headers = {
      'accept': 'application/json',
    };
    let options = {
      method: 'GET',
      headers: headers
    };
    return createFetchAndCall(naicsUrl, options);
  }

}

export default NAICSCodesApi;



/** WEBPACK FOOTER **
 ** ./src/api/naicsApi.js
 **/